(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3366);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const ContentContainer = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "max-w-screen-xl px-6 sm:px-8 md:px-14 " + props.className,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContentContainer);


/***/ }),

/***/ 8254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_EmailSub; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/PopInButton.tsx
var PopInButton = __webpack_require__(2369);
;// CONCATENATED MODULE: ./lib/Types.ts
var Form;
(function(Form) {
    Form[Form["Initial"] = 0] = "Initial";
    Form[Form["Loading"] = 1] = "Loading";
    Form[Form["Success"] = 2] = "Success";
    Form[Form["Error"] = 3] = "Error";
})(Form || (Form = {}));

// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/loader.js
var loader = __webpack_require__(3785);
;// CONCATENATED MODULE: ./components/EmailSub.tsx





const EmailSub = (props)=>{
    const [form, setForm] = (0,react.useState)({
        state: Form.Initial
    });
    const inputEl = (0,react.useRef)(null);
    const inputName = (0,react.useRef)(null);
    const subscribe = async (e)=>{
        e.preventDefault();
        setForm({
            state: Form.Loading
        });
        // @ts-ignore
        const email = inputEl.current.value;
        // @ts-ignore
        const name = inputName.current.value;
        const res = await fetch("/api/sub?email=".concat(email, "&name=").concat(name, "&tag=").concat(props.tag), {
            method: "POST"
        });
        const { error  } = await res.json();
        if (error) {
            setForm({
                state: Form.Error,
                message: error
            });
            return;
        }
        // @ts-ignore
        inputEl.current.value = "";
        setForm({
            state: Form.Success,
            message: "Awesome! Thank you for subscribing!"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "flex h-full w-full flex-col space-y-2",
                onSubmit: subscribe,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onClick: props.onClick,
                        type: "given-name",
                        ref: inputName,
                        "aria-label": "Name for newsletter",
                        className: "w-full border-2 border-brand-pink rounded-none p-4 outline-none",
                        placeholder: "Steve",
                        required: true,
                        autoComplete: "given-name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onClick: props.onClick,
                        type: "email",
                        ref: inputEl,
                        "aria-label": "E-mail for newsletter",
                        className: "w-full border-2 border-brand-pink rounded-none p-4 outline-none",
                        placeholder: "steve@apple.com",
                        required: true,
                        autoComplete: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopInButton["default"], {
                        type: "submit",
                        className: "flex flex-col items-center h-11",
                        ariaLabel: "Submit signup for newsletter",
                        backgroundColor: "bg-brand-turquoise",
                        children: form.state === Form.Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            className: "animate-spin"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-lg ",
                            children: "Sign me up!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm " + (form.state === Form.Error && " text-yellow-500 ") + (form.state === Form.Success && "text-green-400 "),
                children: form.message
            })
        ]
    });
};
/* harmony default export */ var components_EmailSub = (EmailSub);


/***/ }),

/***/ 5970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FloatingNavStatus": function() { return /* binding */ FloatingNavStatus; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _NavButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811);
/* harmony import */ var react_feather__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(408);
/* harmony import */ var react_feather__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8268);
/* harmony import */ var _lib_Transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8080);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






var FloatingNavStatus;
(function(FloatingNavStatus) {
    FloatingNavStatus["TOP"] = "start";
    FloatingNavStatus["PACKAGES"] = "packages";
    FloatingNavStatus["WORKSHOPS"] = "workshops";
    FloatingNavStatus["TRAININGS"] = "trainings";
    FloatingNavStatus["ABOUT"] = "about";
    FloatingNavStatus["CONTACT"] = "contact";
    FloatingNavStatus["RETRO"] = "ai-retro";
    FloatingNavStatus["NONE"] = "none";
})(FloatingNavStatus || (FloatingNavStatus = {}));
const FloatingNav = (props)=>{
    // Somewhere else, even another file
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    function checkIfOnRootPage(hashtag) {
        if (router.pathname !== "/") {
            router.push("/" + (hashtag ? hashtag : ""));
        }
    }
    const [didScroll, setDidScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.initialShowStatus);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let previousScrollYPosition = window.scrollY;
        const scrolledMoreThanThreshold = (currentScrollYPosition)=>Math.abs(currentScrollYPosition - previousScrollYPosition) > 0;
        const updateScrollDirection = ()=>{
            const currentScrollYPosition = window.scrollY;
            if (scrolledMoreThanThreshold(currentScrollYPosition)) {
                setDidScroll(true);
            }
        };
        const onScroll = ()=>window.requestAnimationFrame(updateScrollDirection);
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, []);
    const [isMenuOpen, setIsMenuOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pointer-events-none fixed bottom-0  z-50 mb-4 block w-full md:hidden ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex w-full flex-col items-center ",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pointer-events-auto flex h-14  flex-row justify-around     bg-brand-black font-mono text-xl font-extrabold text-white w-3/4 sm:text-md  md:text-xl  delay-1000 " + (0,_lib_Transitions__WEBPACK_IMPORTED_MODULE_4__/* .getOpacityFromBottomTransition */ .$)(didScroll),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "flex w-full  flex-row justify-center items-center",
                        onClick: ()=>setIsMenuOpen((prevState)=>!prevState),
                        children: !isMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_feather__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    size: 25,
                                    className: "mr-2"
                                }),
                                " MENU"
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_feather__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full  bottom-0  transition-all duration-500 overflow-hidden bg-red-100 -translate-y-[55px] " + (isMenuOpen ? "h-[240px] " : " h-0 "),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "pointer-events-auto flex  flex-col justify-around border-[1px] border-gray-700  bg-brand-black font-mono  font-extrabold text-white " + " delay-1000 " + (0,_lib_Transitions__WEBPACK_IMPORTED_MODULE_4__/* .getOpacityFromBottomTransition */ .$)(didScroll),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    floatingNavStatus: FloatingNavStatus.NONE,
                                    borderColor: "border-brand-black",
                                    onClick: ()=>{
                                        checkIfOnRootPage();
                                        props.scroller.scrollTo("topScrollToElement", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                        setIsMenuOpen(false);
                                    },
                                    buttonType: FloatingNavStatus.TOP,
                                    children: "HOME"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    borderColor: "border-brand-black",
                                    floatingNavStatus: props.floatingNavStatus,
                                    buttonType: FloatingNavStatus.PACKAGES,
                                    onClick: ()=>{
                                        checkIfOnRootPage("#packages");
                                        props.scroller.scrollTo("packages", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                        setIsMenuOpen(false);
                                    },
                                    children: "PACKAGES"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    borderColor: "border-brand-black",
                                    floatingNavStatus: props.floatingNavStatus,
                                    buttonType: FloatingNavStatus.ABOUT,
                                    onClick: ()=>{
                                        checkIfOnRootPage("#about");
                                        props.scroller.scrollTo("about", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                        setIsMenuOpen(false);
                                    },
                                    children: "ABOUT"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    borderColor: "border-brand-black",
                                    floatingNavStatus: props.floatingNavStatus,
                                    buttonType: FloatingNavStatus.TRAININGS,
                                    onClick: ()=>{
                                        checkIfOnRootPage("#trainings");
                                        props.scroller.scrollTo("trainings", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                        setIsMenuOpen(false);
                                    },
                                    children: "TRAININGS"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    borderColor: "border-brand-black",
                                    floatingNavStatus: props.floatingNavStatus,
                                    buttonType: FloatingNavStatus.CONTACT,
                                    onClick: ()=>{
                                        checkIfOnRootPage("#contact");
                                        props.scroller.scrollTo("contact", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                        setIsMenuOpen(false);
                                    },
                                    children: "CONTACT"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    borderColor: "border-brand-black",
                                    floatingNavStatus: props.floatingNavStatus,
                                    buttonType: FloatingNavStatus.RETRO,
                                    onClick: ()=>{
                                        router.push("/airetro");
                                        setIsMenuOpen(false);
                                    },
                                    children: "AI RETRO \uD83D\uDCA1"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FloatingNav);


/***/ }),

/***/ 8641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Logo = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " flex w-full flex-row font-sans  text-xl font-normal text-white  " + props.className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-1.5 w-[35px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 496 496",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M155.343 368.745C53.6624 387.266 7.49245 314.807 0 282.576V33.0777C-0.000121948 6.02483 16.9829 -0.29052 37.4622 0.0102145L238 0.0101861C207.2 0.0101861 174.65 23.5 155.343 42.0936C85.1572 109.687 149.849 178.589 184.814 221.452C209.733 251.999 261 349.5 155.343 368.745Z",
                            fill: "#FF00B5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M386.61 91.192C441.055 43.5971 411.8 18.9996 408.5 16C403 11 391 5 376 0.0101861H466.53C485.526 0.0106692 496 15.0421 496 28.0669L496 457.923C496 487.482 481.515 496.116 456.54 495.999C349.481 495.498 128.97 494.796 69.4301 495.999H30.4692C8.49144 495.999 0.998871 478.464 0.998749 463.434V410.328C49.4502 503.514 194.804 502.011 276.721 437.382C358.638 372.753 329.168 273.555 313.184 247.002C288.803 206.499 250.747 175.861 218.779 142.795C178.348 100.975 203.295 48.1061 276.721 42.0936C343.232 36.6474 378.785 74.659 386.61 91.192Z",
                            fill: "#FF00B5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-molle text-[2.5rem] md:text-[1.2rem] lg:text-[2.5rem] lg:translate-y-[-2px] md:translate-y-[-1px] translate-y-[2px] flex flex-col justify-center ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Scrumify"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const NavButton = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        "aria-label": "Scroll to " + props.buttonType,
        onClick: props.onClick,
        className: "h-[40px] md:h-full transition-colors  hover:text-brand-pink" + " border-b-4 px-1 hover:border-brand-pink sm:px-6 md:px-4 " + (props.floatingNavStatus === props.buttonType ? " border-brand-pink text-brand-pink " : props.borderColor),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: " flex h-full w-full flex-col justify-center transition-transform hover:-translate-y-1 " + (props.floatingNavStatus === props.buttonType && " -translate-y-1 "),
            children: props.children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NavButton);


/***/ }),

/***/ 2369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const PopInButton = (props)=>{
    let className = "popOutBtn__thumbnail w-full min-w-[120px] min-h-[40px] font-mono h-full text-white flex flex-col justify-center items-center text-xl " + (!props.backgroundColor ? " bg-brand-pink " : props.backgroundColor);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "popOutBtn h-full w-full " + props.className,
        children: !props.href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: props.disabled,
            type: props.type,
            "aria-label": props.ariaLabel,
            onClick: props.onClick,
            className: className + " " + (props.disabled ? " cursor-not-allowed " : " cursor-pointer "),
            children: props.children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.href,
            "aria-label": props.ariaLabel,
            className: className,
            children: props.children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PopInButton);


/***/ }),

/***/ 9886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ContentContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(488);
/* harmony import */ var _EmailSub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8254);
/* harmony import */ var fathom_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7184);





const SubsribeSection = (props)=>{
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [success, setSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await fetch("/api/subscribe", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email
                })
            });
            if (response.ok) {
                setSuccess(true);
                setError("");
                (0,fathom_client__WEBPACK_IMPORTED_MODULE_4__/* .trackEvent */ .L9)("NEWSLETTER_SUBSCRIBE");
            } else {
                const data = await response.json();
                setError(data.error || "Something went wrong");
                setSuccess(false);
            }
        } catch (err) {
            setError("Something went wrong");
            setSuccess(false);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex h-full w-full flex-col items-center bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentContainer__WEBPACK_IMPORTED_MODULE_2__["default"], {
            className: "mt-24 mb-24 flex flex-col items-center w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col items-center sm:w-2/3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-xl text-center font-extrabold  md:text-2xl",
                        children: props.text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full self-center pt-8  md:self-start flex flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EmailSub__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            tag: props.tag
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SubsribeSection);


/***/ }),

/***/ 8080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getOpacityFromBottomTransition; }
/* harmony export */ });
function getOpacityFromBottomTransition(inView) {
    return "  duration-1000 transition-all " + (!inView ? " opacity-0 translate-y-12 " : "opacity-100 translate-y-0");
}


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./lib/usePageVisibility.ts

function getBrowserVisibilityProp() {
    if (typeof document.hidden !== "undefined") {
        // Opera 12.10 and Firefox 18 and later support
        return "visibilitychange";
    // @ts-ignore
    } else if (typeof document.msHidden !== "undefined") {
        return "msvisibilitychange";
    // @ts-ignore
    } else if (typeof document.webkitHidden !== "undefined") {
        return "webkitvisibilitychange";
    }
}
function getBrowserDocumentHiddenProp() {
    if (typeof document.hidden !== "undefined") {
        return "hidden";
    // @ts-ignore
    } else if (typeof document.msHidden !== "undefined") {
        return "msHidden";
    // @ts-ignore
    } else if (typeof document.webkitHidden !== "undefined") {
        return "webkitHidden";
    }
}
function getIsDocumentHidden() {
    if (true) {
        // @ts-ignore
        return !document[getBrowserDocumentHiddenProp()];
    } else {}
}
function usePageVisibility() {
    const [isVisible, setIsVisible] = react.useState(getIsDocumentHidden());
    const onVisibilityChange = ()=>setIsVisible(getIsDocumentHidden());
    react.useEffect(()=>{
        const visibilityChange = getBrowserVisibilityProp();
        // @ts-ignore
        document.addEventListener(visibilityChange, onVisibilityChange, false);
        return ()=>{
            // @ts-ignore
            document.removeEventListener(visibilityChange, onVisibilityChange);
        };
    });
    return isVisible;
}

;// CONCATENATED MODULE: ./public/Benjamin.webp
/* harmony default export */ var Benjamin = ({"src":"/_next/static/media/Benjamin.dc9dcb20.webp","height":1920,"width":1080,"blurDataURL":"data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAADQAQCdASoFAAgAAkA4JYwCdAEPDf+hAAD++nZrtdzBD39JuFwFKsyVw+cD4qIRGAdu4AAA","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/getInContact.webp
/* harmony default export */ var getInContact = ({"src":"/_next/static/media/getInContact.ede3c238.webp","height":1200,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRrIAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAAAAAADA4GpAAAAALCyi+geAYti5PxD//9LGuD///X//1cAYv//////RSXs///8//9Haf////r//3k2///85v//hwBWUDggSgAAANABAJ0BKggACAACQDglAE6AHpcUmRoAAP74olNLOBhwMXW24OR8v/YjJKpnD3ZzakDUKEKNpkDDYOBAzQKBj6P77vZy8zNvkAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/Oana.webp
/* harmony default export */ var Oana = ({"src":"/_next/static/media/Oana.b30080a1.webp","height":1920,"width":1080,"blurDataURL":"data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAACwAQCdASoFAAgAAkA4JYwCdADzeZkQAP75W8dcT8d/16c8/ND/vJuSeIa9yAmc4OFf4AAA","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/us_no_bg.webp
/* harmony default export */ var us_no_bg = ({"src":"/_next/static/media/us_no_bg.023c0d28.webp","height":1080,"width":1370,"blurDataURL":"data:image/webp;base64,UklGRpgAAABXRUJQVlA4WAoAAAAQAAAABwAABQAAQUxQSDEAAAAAAD2MkQALY3EM7+Plneq+LmT////+RAAAj/3///9AAACj8P//8mMAABHr///rAAAAAFZQOCBAAAAA0AEAnQEqCAAGAAJAOCWUAnQBDwKBguAA/vfcPKUgM/LyFnkra6aexOD6L5h2fVtLfJ7hj165LCZl9NVS5YAAAA==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
;// CONCATENATED MODULE: ./public/After-Persons-Group.png
/* harmony default export */ var After_Persons_Group = ({"src":"/_next/static/media/After-Persons-Group.ebddd107.png","height":829,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEViKGRSXXZkO2toR3dWPmp4Km83YGNNJU1uNnAdYENMT2ZQYXV0AE55OnqKXJt0bJaZQJVRcoJmTXlUe4hKbHeObKl3dJzBQ5NXAAAAF3RSTlMBVzB6QHVFHV4UV35rotLKvYOiqnFx4jR5rF4AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAA+SURBVHicY2Bg4OLm5GQAARZWDg4Qzc7KA2XwCfCygaUExfgZQTQnqxAzGwsDA4OIsCg7MxNIEyMbOxM7AwAwdwFolSC6mQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/AfterTeam.tsx




const AfterTeam = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "A team that started working together.",
        src: After_Persons_Group,
        className: "w-5/12"
    });
};
/* harmony default export */ var components_AfterTeam = (AfterTeam);

;// CONCATENATED MODULE: ./components/AnimatedWord.tsx


const AnimatedWord = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex flex-col items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute z-10 bg-clip-text text-transparent  transition-opacity duration-1000   " + props.gradient + (!props.animate ? " opacity-0" : " opacity-100"),
                    children: props.word
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute -z-10 translate-x-0.5  translate-y-0.5 text-brand-black  opacity-50  transition-opacity duration-75   ",
                    children: props.word
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " text-white transition-opacity duration-1000 " + (props.animate ? "opacity-0" : "opacity-100"),
                    children: props.word
                })
            ]
        })
    });
};
/* harmony default export */ var components_AnimatedWord = (AnimatedWord);

;// CONCATENATED MODULE: ./public/Before-Persons-Group.png
/* harmony default export */ var Before_Persons_Group = ({"src":"/_next/static/media/Before-Persons-Group.ac11d32e.png","height":829,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEVMaXFlN2pOfIVWO2RDRlJYGk4oVFI7QlQ9VE9mJFVwS309hHtyF1tKaHJpK2NNbXpAZ2pxXYppVX1VXHeJP4lZb4UQWj+cU6NYl59XiZKNRpCJM4ByPnlnE1GDN4ArGaw9AAAAH3RSTlMAS1maBzBCKg4dbypZPH5+o45LQnW3TPNlht2RimeP1lrW1QAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAEJJREFUeJwFwQcCgCAMALEDgRZZ7q3/f6YJktBqgKfH7wuOUl89UwjEfMWstuO7j9iJeFrbxNhBcWWdmUYF1wvR8wNfLQKSpvZajQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/BeforeTeam.tsx




const BeforeTeam = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "A Team that is not working together.",
        src: Before_Persons_Group,
        className: "w-5/12"
    });
};
/* harmony default export */ var components_BeforeTeam = (BeforeTeam);

;// CONCATENATED MODULE: ./components/Custom.tsx


const Custom = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full bg-white flex flex-col  md:items-center justify-center   p-4 md:p-8 " + props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pt-6  font-mono text-2xl  font-extrabold  sm:text-3xl",
                children: props.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "  w-fit flex flex-col md:items-center  pb-8",
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var components_Custom = (Custom);

// EXTERNAL MODULE: ./components/FloatingNav.tsx
var FloatingNav = __webpack_require__(5970);
// EXTERNAL MODULE: ./components/Logo.tsx
var Logo = __webpack_require__(8641);
// EXTERNAL MODULE: ./lib/Transitions.ts
var Transitions = __webpack_require__(8080);
;// CONCATENATED MODULE: ./components/SectionHeader.tsx




const SectionHeader = (props)=>{
    const trainingsHeaderInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-50px 0px"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                ref: trainingsHeaderInView.ref,
                className: "shadowedText  font-mono uppercase text-4xl md:text-4xl  font-extrabold  tracking-wider  text-white lg:text-6xl " + (0,Transitions/* getOpacityFromBottomTransition */.$)(trainingsHeaderInView.inView),
                children: props.title
            }),
            props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: props.subtitleClassName + " shadowedText  text-base font-mono md:text-xl  text-white  " + (0,Transitions/* getOpacityFromBottomTransition */.$)(trainingsHeaderInView.inView),
                children: props.subtitle
            })
        ]
    });
};
/* harmony default export */ var components_SectionHeader = (SectionHeader);

// EXTERNAL MODULE: ./components/SubsribeSection.tsx
var SubsribeSection = __webpack_require__(9886);
;// CONCATENATED MODULE: ./lib/useTotalVisibilityTimer.ts

/**
 * Increment every second
 * @param {boolean} shouldIncrement only increment when true
 * @returns {boolean} The current timer value
 */ function useTotalVisibilityTimer(shouldIncrement) {
    const [timerVal, setTimerVal] = react.useState(0);
    react.useEffect(()=>{
        let intervalId;
        if (shouldIncrement) {
            intervalId = setInterval(()=>{
                setTimerVal(timerVal + 1);
            }, 1000);
        }
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        shouldIncrement,
        timerVal
    ]);
    return timerVal;
}

;// CONCATENATED MODULE: ./lib/gradient.js
/*
 *   Stripe WebGl Gradient Animation
 *   ScrollObserver functionality to disable animation when not scrolled into view has been disabled and
 *   commented out for now.
 */ /* eslint-disable */ //Converting colors to proper format
function normalizeColor(hexCode) {
    return [
        (hexCode >> 16 & 255) / 255,
        (hexCode >> 8 & 255) / 255,
        (255 & hexCode) / 255
    ];
}
[
    "SCREEN",
    "LINEAR_LIGHT"
].reduce((hexCode, t, n)=>Object.assign(hexCode, {
        [t]: n
    }), {});
//Essential functionality of WebGl
//t = width
//n = height
class MiniGl {
    setSize() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 640, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 480;
        this.width = e, this.height = t, this.canvas.width = e, this.canvas.height = t, this.gl.viewport(0, 0, e, t), this.commonUniforms.resolution.value = [
            e,
            t
        ], this.commonUniforms.aspectRatio.value = e / t, this.debug("MiniGL.setSize", {
            width: e,
            height: t
        });
    //  console.log(this.canvas.height,'canvas height');
    }
    //left, right, top, bottom, near, far
    setOrthographicCamera() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -2e3, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2e3;
        this.commonUniforms.projectionMatrix.value = [
            2 / this.width,
            0,
            0,
            0,
            0,
            2 / this.height,
            0,
            0,
            0,
            0,
            2 / (i - s),
            0,
            e,
            t,
            n,
            1
        ], this.debug("setOrthographicCamera", this.commonUniforms.projectionMatrix.value);
    }
    render() {
        this.gl.clearColor(0, 0, 0, 0), this.gl.clearDepth(1), this.meshes.forEach((e)=>e.draw());
    }
    constructor(canvas, width, height, debug = false){
        const _miniGl = this, debug_output = -1 !== document.location.search.toLowerCase().indexOf("debug=webgl");
        _miniGl.canvas = canvas, _miniGl.gl = _miniGl.canvas.getContext("webgl", {
            antialias: true
        }), _miniGl.meshes = [];
        const context = _miniGl.gl;
        width && height && this.setSize(width, height), _miniGl.lastDebugMsg, _miniGl.debug = debug && debug_output ? function(e) {
            const t = new Date();
            t - _miniGl.lastDebugMsg > 1e3 && console.log("---"), console.log(t.toLocaleTimeString() + Array(Math.max(0, 32 - e.length)).join(" ") + e + ": ", ...Array.from(arguments).slice(1)), _miniGl.lastDebugMsg = t;
        } : ()=>{}, Object.defineProperties(_miniGl, {
            Material: {
                enumerable: false,
                value: class {
                    //t = uniform
                    attachUniforms(name, uniforms) {
                        //n  = material
                        const material = this;
                        void 0 === name ? Object.entries(uniforms).forEach((param)=>{
                            let [name, uniform] = param;
                            material.attachUniforms(name, uniform);
                        }) : "array" == uniforms.type ? uniforms.value.forEach((uniform, i)=>material.attachUniforms("".concat(name, "[").concat(i, "]"), uniform)) : "struct" == uniforms.type ? Object.entries(uniforms.value).forEach((param)=>{
                            let [uniform, i] = param;
                            return material.attachUniforms("".concat(name, ".").concat(uniform), i);
                        }) : (_miniGl.debug("Material.attachUniforms", {
                            name: name,
                            uniform: uniforms
                        }), material.uniformInstances.push({
                            uniform: uniforms,
                            location: context.getUniformLocation(material.program, name)
                        }));
                    }
                    constructor(vertexShaders, fragments, uniforms = {}){
                        const material = this;
                        function getShaderByType(type, source) {
                            const shader = context.createShader(type);
                            return context.shaderSource(shader, source), context.compileShader(shader), context.getShaderParameter(shader, context.COMPILE_STATUS) || console.error(context.getShaderInfoLog(shader)), _miniGl.debug("Material.compileShaderSource", {
                                source: source
                            }), shader;
                        }
                        function getUniformVariableDeclarations(uniforms, type) {
                            return Object.entries(uniforms).map((param)=>{
                                let [uniform, value] = param;
                                return value.getDeclaration(uniform, type);
                            }).join("\n");
                        }
                        material.uniforms = uniforms, material.uniformInstances = [];
                        const prefix = "\n              precision highp float;\n            ";
                        material.vertexSource = "\n              ".concat(prefix, "\n              attribute vec4 position;\n              attribute vec2 uv;\n              attribute vec2 uvNorm;\n              ").concat(getUniformVariableDeclarations(_miniGl.commonUniforms, "vertex"), "\n              ").concat(getUniformVariableDeclarations(uniforms, "vertex"), "\n              ").concat(vertexShaders, "\n            "), material.Source = "\n              ".concat(prefix, "\n              ").concat(getUniformVariableDeclarations(_miniGl.commonUniforms, "fragment"), "\n              ").concat(getUniformVariableDeclarations(uniforms, "fragment"), "\n              ").concat(fragments, "\n            "), material.vertexShader = getShaderByType(context.VERTEX_SHADER, material.vertexSource), material.fragmentShader = getShaderByType(context.FRAGMENT_SHADER, material.Source), material.program = context.createProgram(), context.attachShader(material.program, material.vertexShader), context.attachShader(material.program, material.fragmentShader), context.linkProgram(material.program), context.getProgramParameter(material.program, context.LINK_STATUS) || console.error(context.getProgramInfoLog(material.program)), context.useProgram(material.program), material.attachUniforms(void 0, _miniGl.commonUniforms), material.attachUniforms(void 0, material.uniforms);
                    }
                }
            },
            Uniform: {
                enumerable: !1,
                value: class {
                    update(value) {
                        void 0 !== this.value && context["uniform".concat(this.typeFn)](value, 0 === this.typeFn.indexOf("Matrix") ? this.transpose : this.value, 0 === this.typeFn.indexOf("Matrix") ? this.value : null);
                    }
                    //e - name
                    //t - type
                    //n - length
                    getDeclaration(name, type, length) {
                        const uniform = this;
                        if (uniform.excludeFrom !== type) {
                            if ("array" === uniform.type) return uniform.value[0].getDeclaration(name, type, uniform.value.length) + "\nconst int ".concat(name, "_length = ").concat(uniform.value.length, ";");
                            if ("struct" === uniform.type) {
                                let name_no_prefix = name.replace("u_", "");
                                return name_no_prefix = name_no_prefix.charAt(0).toUpperCase() + name_no_prefix.slice(1), "uniform struct ".concat(name_no_prefix, " \n                                {\n") + Object.entries(uniform.value).map((param)=>{
                                    let [name, uniform] = param;
                                    return uniform.getDeclaration(name, type).replace(/^uniform/, "");
                                }).join("") + "\n} ".concat(name).concat(length > 0 ? "[".concat(length, "]") : "", ";");
                            }
                            return "uniform ".concat(uniform.type, " ").concat(name).concat(length > 0 ? "[".concat(length, "]") : "", ";");
                        }
                    }
                    constructor(e){
                        this.type = "float", Object.assign(this, e);
                        this.typeFn = ({
                            float: "1f",
                            int: "1i",
                            vec2: "2fv",
                            vec3: "3fv",
                            vec4: "4fv",
                            mat4: "Matrix4fv"
                        })[this.type] || "1f", this.update();
                    }
                }
            },
            PlaneGeometry: {
                enumerable: !1,
                value: class {
                    setTopology() {
                        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                        const n = this;
                        n.xSegCount = e, n.ySegCount = t, n.vertexCount = (n.xSegCount + 1) * (n.ySegCount + 1), n.quadCount = n.xSegCount * n.ySegCount * 2, n.attributes.uv.values = new Float32Array(2 * n.vertexCount), n.attributes.uvNorm.values = new Float32Array(2 * n.vertexCount), n.attributes.index.values = new Uint16Array(3 * n.quadCount);
                        for(let e1 = 0; e1 <= n.ySegCount; e1++)for(let t1 = 0; t1 <= n.xSegCount; t1++){
                            const i = e1 * (n.xSegCount + 1) + t1;
                            if (n.attributes.uv.values[2 * i] = t1 / n.xSegCount, n.attributes.uv.values[2 * i + 1] = 1 - e1 / n.ySegCount, n.attributes.uvNorm.values[2 * i] = t1 / n.xSegCount * 2 - 1, n.attributes.uvNorm.values[2 * i + 1] = 1 - e1 / n.ySegCount * 2, t1 < n.xSegCount && e1 < n.ySegCount) {
                                const s = e1 * n.xSegCount + t1;
                                n.attributes.index.values[6 * s] = i, n.attributes.index.values[6 * s + 1] = i + 1 + n.xSegCount, n.attributes.index.values[6 * s + 2] = i + 1, n.attributes.index.values[6 * s + 3] = i + 1, n.attributes.index.values[6 * s + 4] = i + 1 + n.xSegCount, n.attributes.index.values[6 * s + 5] = i + 2 + n.xSegCount;
                            }
                        }
                        n.attributes.uv.update(), n.attributes.uvNorm.update(), n.attributes.index.update(), _miniGl.debug("Geometry.setTopology", {
                            uv: n.attributes.uv,
                            uvNorm: n.attributes.uvNorm,
                            index: n.attributes.index
                        });
                    }
                    setSize() {
                        let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, orientation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "xz";
                        const geometry = this;
                        geometry.width = width, geometry.height = height, geometry.orientation = orientation, geometry.attributes.position.values && geometry.attributes.position.values.length === 3 * geometry.vertexCount || (geometry.attributes.position.values = new Float32Array(3 * geometry.vertexCount));
                        const o = width / -2, r = height / -2, segment_width = width / geometry.xSegCount, segment_height = height / geometry.ySegCount;
                        for(let yIndex = 0; yIndex <= geometry.ySegCount; yIndex++){
                            const t = r + yIndex * segment_height;
                            for(let xIndex = 0; xIndex <= geometry.xSegCount; xIndex++){
                                const r1 = o + xIndex * segment_width, l = yIndex * (geometry.xSegCount + 1) + xIndex;
                                geometry.attributes.position.values[3 * l + "xyz".indexOf(orientation[0])] = r1, geometry.attributes.position.values[3 * l + "xyz".indexOf(orientation[1])] = -t;
                            }
                        }
                        geometry.attributes.position.update(), _miniGl.debug("Geometry.setSize", {
                            position: geometry.attributes.position
                        });
                    }
                    constructor(width, height, n, i, orientation){
                        context.createBuffer(), this.attributes = {
                            position: new _miniGl.Attribute({
                                target: context.ARRAY_BUFFER,
                                size: 3
                            }),
                            uv: new _miniGl.Attribute({
                                target: context.ARRAY_BUFFER,
                                size: 2
                            }),
                            uvNorm: new _miniGl.Attribute({
                                target: context.ARRAY_BUFFER,
                                size: 2
                            }),
                            index: new _miniGl.Attribute({
                                target: context.ELEMENT_ARRAY_BUFFER,
                                size: 3,
                                type: context.UNSIGNED_SHORT
                            })
                        }, this.setTopology(n, i), this.setSize(width, height, orientation);
                    }
                }
            },
            Mesh: {
                enumerable: !1,
                value: class {
                    draw() {
                        context.useProgram(this.material.program), this.material.uniformInstances.forEach((param)=>{
                            let { uniform: e , location: t  } = param;
                            return e.update(t);
                        }), this.attributeInstances.forEach((param)=>{
                            let { attribute: e , location: t  } = param;
                            return e.use(t);
                        }), context.drawElements(this.wireframe ? context.LINES : context.TRIANGLES, this.geometry.attributes.index.values.length, context.UNSIGNED_SHORT, 0);
                    }
                    remove() {
                        _miniGl.meshes = _miniGl.meshes.filter((e)=>e != this);
                    }
                    constructor(geometry, material){
                        const mesh = this;
                        mesh.geometry = geometry, mesh.material = material, mesh.wireframe = !1, mesh.attributeInstances = [], Object.entries(mesh.geometry.attributes).forEach((param)=>{
                            let [e, attribute] = param;
                            mesh.attributeInstances.push({
                                attribute: attribute,
                                location: attribute.attach(e, mesh.material.program)
                            });
                        }), _miniGl.meshes.push(mesh), _miniGl.debug("Mesh.constructor", {
                            mesh: mesh
                        });
                    }
                }
            },
            Attribute: {
                enumerable: !1,
                value: class {
                    update() {
                        void 0 !== this.values && (context.bindBuffer(this.target, this.buffer), context.bufferData(this.target, this.values, context.STATIC_DRAW));
                    }
                    attach(e, t) {
                        const n = context.getAttribLocation(t, e);
                        return this.target === context.ARRAY_BUFFER && (context.enableVertexAttribArray(n), context.vertexAttribPointer(n, this.size, this.type, this.normalized, 0, 0)), n;
                    }
                    use(e) {
                        context.bindBuffer(this.target, this.buffer), this.target === context.ARRAY_BUFFER && (context.enableVertexAttribArray(e), context.vertexAttribPointer(e, this.size, this.type, this.normalized, 0, 0));
                    }
                    constructor(e){
                        this.type = context.FLOAT, this.normalized = !1, this.buffer = context.createBuffer(), Object.assign(this, e), this.update();
                    }
                }
            }
        });
        const a = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        _miniGl.commonUniforms = {
            projectionMatrix: new _miniGl.Uniform({
                type: "mat4",
                value: a
            }),
            modelViewMatrix: new _miniGl.Uniform({
                type: "mat4",
                value: a
            }),
            resolution: new _miniGl.Uniform({
                type: "vec2",
                value: [
                    1,
                    1
                ]
            }),
            aspectRatio: new _miniGl.Uniform({
                type: "float",
                value: 1
            })
        };
    }
}
//Sets initial properties
function e(object, propertyName, val) {
    return propertyName in object ? Object.defineProperty(object, propertyName, {
        value: val,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : object[propertyName] = val, object;
}
//Gradient object
class Gradient {
    async connect() {
        this.shaderFiles = {
            vertex: "varying vec3 v_color;\n\nvoid main() {\n  float time = u_time * u_global.noiseSpeed;\n\n  vec2 noiseCoord = resolution * uvNorm * u_global.noiseFreq;\n\n  vec2 st = 1. - uvNorm.xy;\n\n  //\n  // Tilting the plane\n  //\n\n  // Front-to-back tilt\n  float tilt = resolution.y / 2.0 * uvNorm.y;\n\n  // Left-to-right angle\n  float incline = resolution.x * uvNorm.x / 2.0 * u_vertDeform.incline;\n\n  // Up-down shift to offset incline\n  float offset = resolution.x / 2.0 * u_vertDeform.incline * mix(u_vertDeform.offsetBottom, u_vertDeform.offsetTop, uv.y);\n\n  //\n  // Vertex noise\n  //\n\n  float noise = snoise(vec3(\n    noiseCoord.x * u_vertDeform.noiseFreq.x + time * u_vertDeform.noiseFlow,\n    noiseCoord.y * u_vertDeform.noiseFreq.y,\n    time * u_vertDeform.noiseSpeed + u_vertDeform.noiseSeed\n  )) * u_vertDeform.noiseAmp;\n\n  // Fade noise to zero at edges\n  noise *= 1.0 - pow(abs(uvNorm.y), 2.0);\n\n  // Clamp to 0\n  noise = max(0.0, noise);\n\n  vec3 pos = vec3(\n    position.x,\n    position.y + tilt + incline + noise - offset,\n    position.z\n  );\n\n  //\n  // Vertex color, to be passed to fragment shader\n  //\n\n  if (u_active_colors[0] == 1.) {\n    v_color = u_baseColor;\n  }\n\n  for (int i = 0; i < u_waveLayers_length; i++) {\n    if (u_active_colors[i + 1] == 1.) {\n      WaveLayers layer = u_waveLayers[i];\n\n      float noise = smoothstep(\n        layer.noiseFloor,\n        layer.noiseCeil,\n        snoise(vec3(\n          noiseCoord.x * layer.noiseFreq.x + time * layer.noiseFlow,\n          noiseCoord.y * layer.noiseFreq.y,\n          time * layer.noiseSpeed + layer.noiseSeed\n        )) / 2.0 + 0.5\n      );\n\n      v_color = blendNormal(v_color, layer.color, pow(noise, 4.));\n    }\n  }\n\n  //\n  // Finish\n  //\n\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);\n}",
            noise: "//\n// Description : Array and textureless GLSL 2D/3D/4D simplex\n//               noise functions.\n//      Author : Ian McEwan, Ashima Arts.\n//  Maintainer : stegu\n//     Lastmod : 20110822 (ijm)\n//     License : Copyright (C) 2011 Ashima Arts. All rights reserved.\n//               Distributed under the MIT License. See LICENSE file.\n//               https://github.com/ashima/webgl-noise\n//               https://github.com/stegu/webgl-noise\n//\n\nvec3 mod289(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289(vec4 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute(vec4 x) {\n    return mod289(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt(vec4 r)\n{\n  return 1.79284291400159 - 0.85373472095314 * r;\n}\n\nfloat snoise(vec3 v)\n{\n  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;\n  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);\n\n// First corner\n  vec3 i  = floor(v + dot(v, C.yyy) );\n  vec3 x0 =   v - i + dot(i, C.xxx) ;\n\n// Other corners\n  vec3 g = step(x0.yzx, x0.xyz);\n  vec3 l = 1.0 - g;\n  vec3 i1 = min( g.xyz, l.zxy );\n  vec3 i2 = max( g.xyz, l.zxy );\n\n  //   x0 = x0 - 0.0 + 0.0 * C.xxx;\n  //   x1 = x0 - i1  + 1.0 * C.xxx;\n  //   x2 = x0 - i2  + 2.0 * C.xxx;\n  //   x3 = x0 - 1.0 + 3.0 * C.xxx;\n  vec3 x1 = x0 - i1 + C.xxx;\n  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y\n  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y\n\n// Permutations\n  i = mod289(i);\n  vec4 p = permute( permute( permute(\n            i.z + vec4(0.0, i1.z, i2.z, 1.0 ))\n          + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))\n          + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));\n\n// Gradients: 7x7 points over a square, mapped onto an octahedron.\n// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)\n  float n_ = 0.142857142857; // 1.0/7.0\n  vec3  ns = n_ * D.wyz - D.xzx;\n\n  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)\n\n  vec4 x_ = floor(j * ns.z);\n  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)\n\n  vec4 x = x_ *ns.x + ns.yyyy;\n  vec4 y = y_ *ns.x + ns.yyyy;\n  vec4 h = 1.0 - abs(x) - abs(y);\n\n  vec4 b0 = vec4( x.xy, y.xy );\n  vec4 b1 = vec4( x.zw, y.zw );\n\n  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;\n  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;\n  vec4 s0 = floor(b0)*2.0 + 1.0;\n  vec4 s1 = floor(b1)*2.0 + 1.0;\n  vec4 sh = -step(h, vec4(0.0));\n\n  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;\n  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;\n\n  vec3 p0 = vec3(a0.xy,h.x);\n  vec3 p1 = vec3(a0.zw,h.y);\n  vec3 p2 = vec3(a1.xy,h.z);\n  vec3 p3 = vec3(a1.zw,h.w);\n\n//Normalise gradients\n  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));\n  p0 *= norm.x;\n  p1 *= norm.y;\n  p2 *= norm.z;\n  p3 *= norm.w;\n\n// Mix final noise value\n  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);\n  m = m * m;\n  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),\n                                dot(p2,x2), dot(p3,x3) ) );\n}",
            blend: "//\n// https://github.com/jamieowen/glsl-blend\n//\n\n// Normal\n\nvec3 blendNormal(vec3 base, vec3 blend) {\n	return blend;\n}\n\nvec3 blendNormal(vec3 base, vec3 blend, float opacity) {\n	return (blendNormal(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Screen\n\nfloat blendScreen(float base, float blend) {\n	return 1.0-((1.0-base)*(1.0-blend));\n}\n\nvec3 blendScreen(vec3 base, vec3 blend) {\n	return vec3(blendScreen(base.r,blend.r),blendScreen(base.g,blend.g),blendScreen(base.b,blend.b));\n}\n\nvec3 blendScreen(vec3 base, vec3 blend, float opacity) {\n	return (blendScreen(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Multiply\n\nvec3 blendMultiply(vec3 base, vec3 blend) {\n	return base*blend;\n}\n\nvec3 blendMultiply(vec3 base, vec3 blend, float opacity) {\n	return (blendMultiply(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Overlay\n\nfloat blendOverlay(float base, float blend) {\n	return base<0.5?(2.0*base*blend):(1.0-2.0*(1.0-base)*(1.0-blend));\n}\n\nvec3 blendOverlay(vec3 base, vec3 blend) {\n	return vec3(blendOverlay(base.r,blend.r),blendOverlay(base.g,blend.g),blendOverlay(base.b,blend.b));\n}\n\nvec3 blendOverlay(vec3 base, vec3 blend, float opacity) {\n	return (blendOverlay(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Hard light\n\nvec3 blendHardLight(vec3 base, vec3 blend) {\n	return blendOverlay(blend,base);\n}\n\nvec3 blendHardLight(vec3 base, vec3 blend, float opacity) {\n	return (blendHardLight(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Soft light\n\nfloat blendSoftLight(float base, float blend) {\n	return (blend<0.5)?(2.0*base*blend+base*base*(1.0-2.0*blend)):(sqrt(base)*(2.0*blend-1.0)+2.0*base*(1.0-blend));\n}\n\nvec3 blendSoftLight(vec3 base, vec3 blend) {\n	return vec3(blendSoftLight(base.r,blend.r),blendSoftLight(base.g,blend.g),blendSoftLight(base.b,blend.b));\n}\n\nvec3 blendSoftLight(vec3 base, vec3 blend, float opacity) {\n	return (blendSoftLight(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Color dodge\n\nfloat blendColorDodge(float base, float blend) {\n	return (blend==1.0)?blend:min(base/(1.0-blend),1.0);\n}\n\nvec3 blendColorDodge(vec3 base, vec3 blend) {\n	return vec3(blendColorDodge(base.r,blend.r),blendColorDodge(base.g,blend.g),blendColorDodge(base.b,blend.b));\n}\n\nvec3 blendColorDodge(vec3 base, vec3 blend, float opacity) {\n	return (blendColorDodge(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Color burn\n\nfloat blendColorBurn(float base, float blend) {\n	return (blend==0.0)?blend:max((1.0-((1.0-base)/blend)),0.0);\n}\n\nvec3 blendColorBurn(vec3 base, vec3 blend) {\n	return vec3(blendColorBurn(base.r,blend.r),blendColorBurn(base.g,blend.g),blendColorBurn(base.b,blend.b));\n}\n\nvec3 blendColorBurn(vec3 base, vec3 blend, float opacity) {\n	return (blendColorBurn(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Vivid Light\n\nfloat blendVividLight(float base, float blend) {\n	return (blend<0.5)?blendColorBurn(base,(2.0*blend)):blendColorDodge(base,(2.0*(blend-0.5)));\n}\n\nvec3 blendVividLight(vec3 base, vec3 blend) {\n	return vec3(blendVividLight(base.r,blend.r),blendVividLight(base.g,blend.g),blendVividLight(base.b,blend.b));\n}\n\nvec3 blendVividLight(vec3 base, vec3 blend, float opacity) {\n	return (blendVividLight(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Lighten\n\nfloat blendLighten(float base, float blend) {\n	return max(blend,base);\n}\n\nvec3 blendLighten(vec3 base, vec3 blend) {\n	return vec3(blendLighten(base.r,blend.r),blendLighten(base.g,blend.g),blendLighten(base.b,blend.b));\n}\n\nvec3 blendLighten(vec3 base, vec3 blend, float opacity) {\n	return (blendLighten(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Linear burn\n\nfloat blendLinearBurn(float base, float blend) {\n	// Note : Same implementation as BlendSubtractf\n	return max(base+blend-1.0,0.0);\n}\n\nvec3 blendLinearBurn(vec3 base, vec3 blend) {\n	// Note : Same implementation as BlendSubtract\n	return max(base+blend-vec3(1.0),vec3(0.0));\n}\n\nvec3 blendLinearBurn(vec3 base, vec3 blend, float opacity) {\n	return (blendLinearBurn(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Linear dodge\n\nfloat blendLinearDodge(float base, float blend) {\n	// Note : Same implementation as BlendAddf\n	return min(base+blend,1.0);\n}\n\nvec3 blendLinearDodge(vec3 base, vec3 blend) {\n	// Note : Same implementation as BlendAdd\n	return min(base+blend,vec3(1.0));\n}\n\nvec3 blendLinearDodge(vec3 base, vec3 blend, float opacity) {\n	return (blendLinearDodge(base, blend) * opacity + base * (1.0 - opacity));\n}\n\n// Linear light\n\nfloat blendLinearLight(float base, float blend) {\n	return blend<0.5?blendLinearBurn(base,(2.0*blend)):blendLinearDodge(base,(2.0*(blend-0.5)));\n}\n\nvec3 blendLinearLight(vec3 base, vec3 blend) {\n	return vec3(blendLinearLight(base.r,blend.r),blendLinearLight(base.g,blend.g),blendLinearLight(base.b,blend.b));\n}\n\nvec3 blendLinearLight(vec3 base, vec3 blend, float opacity) {\n	return (blendLinearLight(base, blend) * opacity + base * (1.0 - opacity));\n}",
            fragment: "varying vec3 v_color;\n\nvoid main() {\n  vec3 color = v_color;\n  if (u_darken_top == 1.0) {\n    vec2 st = gl_FragCoord.xy/resolution.xy;\n    color.g -= pow(st.y + sin(-12.0) * st.x, u_shadow_power) * 0.4;\n  }\n  gl_FragColor = vec4(color, 1.0);\n}"
        }, this.conf = {
            presetName: "",
            wireframe: false,
            density: [
                0.06,
                0.16
            ],
            zoom: 1,
            rotation: 0,
            playing: true
        }, document.querySelectorAll("canvas").length < 1 ? console.log("DID NOT LOAD HERO STRIPE CANVAS") : (this.minigl = new MiniGl(this.el, null, null, !0), requestAnimationFrame(()=>{
            this.el && (this.computedCanvasStyle = getComputedStyle(this.el), this.waitForCssVars());
        }));
    /*
                this.scrollObserver = await s.create(.1, !1),
                this.scrollObserver.observe(this.el),
                this.scrollObserver.onSeparate(() => {
                    window.removeEventListener("scroll", this.handleScroll), window.removeEventListener("mousedown", this.handleMouseDown), window.removeEventListener("mouseup", this.handleMouseUp), window.removeEventListener("keydown", this.handleKeyDown), this.isIntersecting = !1, this.conf.playing && this.pause()
                }),
                this.scrollObserver.onIntersect(() => {
                    window.addEventListener("scroll", this.handleScroll), window.addEventListener("mousedown", this.handleMouseDown), window.addEventListener("mouseup", this.handleMouseUp), window.addEventListener("keydown", this.handleKeyDown), this.isIntersecting = !0, this.addIsLoadedClass(), this.play()
                })*/ }
    disconnect() {
        this.scrollObserver && (window.removeEventListener("scroll", this.handleScroll), window.removeEventListener("mousedown", this.handleMouseDown), window.removeEventListener("mouseup", this.handleMouseUp), window.removeEventListener("keydown", this.handleKeyDown), this.scrollObserver.disconnect()), window.removeEventListener("resize", this.resize);
    }
    initMaterial() {
        this.uniforms = {
            u_time: new this.minigl.Uniform({
                value: 0
            }),
            u_shadow_power: new this.minigl.Uniform({
                value: 5
            }),
            u_darken_top: new this.minigl.Uniform({
                value: "" === this.el.dataset.jsDarkenTop ? 1 : 0
            }),
            u_active_colors: new this.minigl.Uniform({
                value: this.activeColors,
                type: "vec4"
            }),
            u_global: new this.minigl.Uniform({
                value: {
                    noiseFreq: new this.minigl.Uniform({
                        value: [
                            this.freqX,
                            this.freqY
                        ],
                        type: "vec2"
                    }),
                    noiseSpeed: new this.minigl.Uniform({
                        value: 5e-6
                    })
                },
                type: "struct"
            }),
            u_vertDeform: new this.minigl.Uniform({
                value: {
                    incline: new this.minigl.Uniform({
                        value: Math.sin(this.angle) / Math.cos(this.angle)
                    }),
                    offsetTop: new this.minigl.Uniform({
                        value: -0.5
                    }),
                    offsetBottom: new this.minigl.Uniform({
                        value: -0.5
                    }),
                    noiseFreq: new this.minigl.Uniform({
                        value: [
                            3,
                            4
                        ],
                        type: "vec2"
                    }),
                    noiseAmp: new this.minigl.Uniform({
                        value: this.amp
                    }),
                    noiseSpeed: new this.minigl.Uniform({
                        value: 10
                    }),
                    noiseFlow: new this.minigl.Uniform({
                        value: 3
                    }),
                    noiseSeed: new this.minigl.Uniform({
                        value: this.seed
                    })
                },
                type: "struct",
                excludeFrom: "fragment"
            }),
            u_baseColor: new this.minigl.Uniform({
                value: this.sectionColors[0],
                type: "vec3",
                excludeFrom: "fragment"
            }),
            u_waveLayers: new this.minigl.Uniform({
                value: [],
                excludeFrom: "fragment",
                type: "array"
            })
        };
        for(let e = 1; e < this.sectionColors.length; e += 1)this.uniforms.u_waveLayers.value.push(new this.minigl.Uniform({
            value: {
                color: new this.minigl.Uniform({
                    value: this.sectionColors[e],
                    type: "vec3"
                }),
                noiseFreq: new this.minigl.Uniform({
                    value: [
                        2 + e / this.sectionColors.length,
                        3 + e / this.sectionColors.length
                    ],
                    type: "vec2"
                }),
                noiseSpeed: new this.minigl.Uniform({
                    value: 11 + 0.3 * e
                }),
                noiseFlow: new this.minigl.Uniform({
                    value: 6.5 + 0.3 * e
                }),
                noiseSeed: new this.minigl.Uniform({
                    value: this.seed + 10 * e
                }),
                noiseFloor: new this.minigl.Uniform({
                    value: 0.1
                }),
                noiseCeil: new this.minigl.Uniform({
                    value: 0.63 + 0.07 * e
                })
            },
            type: "struct"
        }));
        return this.vertexShader = [
            this.shaderFiles.noise,
            this.shaderFiles.blend,
            this.shaderFiles.vertex
        ].join("\n\n"), new this.minigl.Material(this.vertexShader, this.shaderFiles.fragment, this.uniforms);
    }
    initMesh() {
        this.material = this.initMaterial(), this.geometry = new this.minigl.PlaneGeometry(), this.mesh = new this.minigl.Mesh(this.geometry, this.material);
    }
    shouldSkipFrame(e) {
        return !!window.document.hidden || !this.conf.playing || parseInt(e, 10) % 2 == 0 || void 0;
    }
    updateFrequency(e) {
        this.freqX += e, this.freqY += e;
    }
    toggleColor(index) {
        this.activeColors[index] = 0 === this.activeColors[index] ? 1 : 0;
    }
    showGradientLegend() {
        this.width > this.minWidth && (this.isGradientLegendVisible = !0, document.body.classList.add("isGradientLegendVisible"));
    }
    hideGradientLegend() {
        this.isGradientLegendVisible = !1, document.body.classList.remove("isGradientLegendVisible");
    }
    init() {
        this.initGradientColors(), this.initMesh(), this.resize(), requestAnimationFrame(this.animate), window.addEventListener("resize", this.resize);
    }
    /*
   * Waiting for the css variables to become available, usually on page load before we can continue.
   * Using default colors assigned below if no variables have been found after maxCssVarRetries
   */ waitForCssVars() {
        if (this.computedCanvasStyle && -1 !== this.computedCanvasStyle.getPropertyValue("--gradient-color-1").indexOf("#")) this.init(), this.addIsLoadedClass();
        else {
            if (this.cssVarRetries += 1, this.cssVarRetries > this.maxCssVarRetries) {
                return this.sectionColors = [
                    16711680,
                    16711680,
                    16711935,
                    65280,
                    255
                ], void this.init();
            }
            requestAnimationFrame(()=>this.waitForCssVars());
        }
    }
    updateGradientColors() {}
    /*
   * Initializes the four section colors by retrieving them from css variables.
   */ initGradientColors() {
        this.sectionColors = [
            "--gradient-color-1",
            "--gradient-color-2",
            "--gradient-color-3",
            "--gradient-color-4"
        ].map((cssPropertyName)=>{
            let hex = this.computedCanvasStyle.getPropertyValue(cssPropertyName).trim();
            //Check if shorthand hex value was used and double the length so the conversion in normalizeColor will work.
            if (4 === hex.length) {
                const hexTemp = hex.substr(1).split("").map((hexTemp)=>hexTemp + hexTemp).join("");
                hex = "#".concat(hexTemp);
            }
            return hex && "0x".concat(hex.substr(1));
        }).filter(Boolean).map(normalizeColor);
    }
    initGradient(s) {}
    constructor(...t){
        e(this, "el", void 0), e(this, "cssVarRetries", 0), e(this, "maxCssVarRetries", 200), e(this, "angle", 0), e(this, "isLoadedClass", !1), e(this, "isScrolling", !1), /*e(this, "isStatic", o.disableAmbientAnimations()),*/ e(this, "scrollingTimeout", void 0), e(this, "scrollingRefreshDelay", 200), e(this, "isIntersecting", !1), e(this, "shaderFiles", void 0), e(this, "vertexShader", void 0), e(this, "sectionColors", void 0), e(this, "computedCanvasStyle", void 0), e(this, "conf", void 0), e(this, "uniforms", void 0), e(this, "t", 1253106), e(this, "last", 0), e(this, "width", void 0), e(this, "minWidth", 1111), e(this, "height", 600), e(this, "xSegCount", void 0), e(this, "ySegCount", void 0), e(this, "mesh", void 0), e(this, "material", void 0), e(this, "geometry", void 0), e(this, "minigl", void 0), e(this, "scrollObserver", void 0), e(this, "amp", 320), e(this, "seed", 5), e(this, "freqX", 14e-5), e(this, "freqY", 29e-5), e(this, "freqDelta", 1e-5), e(this, "activeColors", [
            1,
            1,
            1,
            1
        ]), e(this, "isMetaKey", !1), e(this, "isGradientLegendVisible", !1), e(this, "isMouseDown", !1), e(this, "handleScroll", ()=>{
            clearTimeout(this.scrollingTimeout), this.scrollingTimeout = setTimeout(this.handleScrollEnd, this.scrollingRefreshDelay), this.isGradientLegendVisible && this.hideGradientLegend(), this.conf.playing && (this.isScrolling = !0, this.pause());
        }), e(this, "handleScrollEnd", ()=>{
            this.isScrolling = !1, this.isIntersecting && this.play();
        }), e(this, "resize", ()=>{
            this.width = window.innerWidth, this.minigl.setSize(this.width, this.height), this.minigl.setOrthographicCamera(), this.xSegCount = Math.ceil(this.width * this.conf.density[0]), this.ySegCount = Math.ceil(this.height * this.conf.density[1]), this.mesh.geometry.setTopology(this.xSegCount, this.ySegCount), this.mesh.geometry.setSize(this.width, this.height), this.mesh.material.uniforms.u_shadow_power.value = this.width < 600 ? 5 : 6;
        }), e(this, "handleMouseDown", (e)=>{
            this.isGradientLegendVisible && (this.isMetaKey = e.metaKey, this.isMouseDown = !0, !1 === this.conf.playing && requestAnimationFrame(this.animate));
        }), e(this, "handleMouseUp", ()=>{
            this.isMouseDown = !1;
        }), e(this, "animate", (e)=>{
            if (!this.shouldSkipFrame(e) || this.isMouseDown) {
                if (this.t += Math.min(e - this.last, 1e3 / 15), this.last = e, this.isMouseDown) {
                    let e1 = 160;
                    this.isMetaKey && (e1 = -160), this.t += e1;
                }
                this.mesh.material.uniforms.u_time.value = this.t, this.minigl.render();
            }
            if (0 !== this.last && this.isStatic) return this.minigl.render(), void this.disconnect();
            /*this.isIntersecting && */ (this.conf.playing || this.isMouseDown) && requestAnimationFrame(this.animate);
        }), e(this, "addIsLoadedClass", ()=>{
            /*this.isIntersecting && */ !this.isLoadedClass && (this.isLoadedClass = !0, this.el.classList.add("isLoaded"), setTimeout(()=>{
                this.el.parentElement.classList.add("isLoaded");
            }, 3e3));
        }), e(this, "pause", ()=>{
            this.conf.playing = false;
        }), e(this, "play", ()=>{
            requestAnimationFrame(this.animate), this.conf.playing = true;
        }), e(this, "initGradient", (selector)=>{
            this.el = document.querySelector(selector);
            this.connect();
            return this;
        });
    }
}
/* harmony default export */ var gradient = ((/* unused pure expression or super */ null && (Gradient))); /* eslint-enable */ 

;// CONCATENATED MODULE: ./pages/index.tsx









// @ts-ignore














dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8254)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8254)
            ]
    }
});
const FooterBar = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(95)]).then(__webpack_require__.bind(__webpack_require__, 2095)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2095)
            ]
    }
});
const Header = dynamic_default()(()=>__webpack_require__.e(/* import() */ 505).then(__webpack_require__.bind(__webpack_require__, 3505)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3505)
            ]
    }
});
const Member = dynamic_default()(()=>__webpack_require__.e(/* import() */ 775).then(__webpack_require__.bind(__webpack_require__, 7775)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7775)
            ]
    }
});
const BookACall = dynamic_default()(()=>__webpack_require__.e(/* import() */ 384).then(__webpack_require__.bind(__webpack_require__, 8384)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8384)
            ]
    }
});
const Package = dynamic_default()(()=>__webpack_require__.e(/* import() */ 68).then(__webpack_require__.bind(__webpack_require__, 9068)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9068)
            ]
    }
});
const ContentContainer = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 488)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(488)
            ]
    }
});
const pages_FloatingNav = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5970)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5970)
            ]
    }
});
const PopInButton = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2369)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2369)
            ]
    }
});
const Home = ()=>{
    const Scroll = __webpack_require__(6261);
    let scroller = Scroll.scroller;
    const TrainingsSection = Scroll.Element;
    const PackagesSection = Scroll.Element;
    const AboutSection = Scroll.Element;
    const TopSection = Scroll.Element;
    const ContactSection = Scroll.Element;
    const StartNowSection = Scroll.Element;
    const [floatingNavStatus, setFloatingNavStatus] = (0,react.useState)(FloatingNav.FloatingNavStatus.TOP);
    const trainingsInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "0px 0px"
    });
    const workshopsInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "-0px 0px"
    });
    const packagesInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "-0px 0px"
    });
    const aboutInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "-50px 0px"
    });
    const topInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "0px 0px"
    });
    const contactInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: false,
        rootMargin: "-300px 0px"
    });
    (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "0px 0px"
    });
    const contactImageSectionInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-50px 0px"
    });
    const contactActionSectionInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "-50px 0px"
    });
    const isPageVisible = usePageVisibility();
    // Change the title based on page visibility
    (0,react.useEffect)(()=>{
        const gradient = new Gradient();
        gradient.initGradient("#gradient-canvas");
    }, []);
    let //enum with three values one, two,three
    animStatus;
    (function(animStatus) {
        animStatus[animStatus["ONE"] = 0] = "ONE";
        animStatus[animStatus["TWO"] = 1] = "TWO";
        animStatus[animStatus["THREE"] = 2] = "THREE";
    })(animStatus || (animStatus = {}));
    const [animStatusInstance, setAnimStatusInstance] = (0,react.useState)(animStatus.ONE);
    const [lastTimerVal, setLastTimerVal] = (0,react.useState)(0);
    const timerVal = useTotalVisibilityTimer(isPageVisible);
    (0,react.useEffect)(()=>{
        //iterate between page enum after timerVal
        if (timerVal > lastTimerVal + 1) {
            setLastTimerVal(timerVal);
            if (animStatusInstance === animStatus.ONE) {
                setAnimStatusInstance(animStatus.TWO);
            } else if (animStatusInstance === animStatus.TWO) {
                setAnimStatusInstance(animStatus.THREE);
            } else if (animStatusInstance === animStatus.THREE) {
                setAnimStatusInstance(animStatus.ONE);
            }
        }
    }, [
        timerVal
    ]);
    (0,react.useEffect)(()=>{
        if (packagesInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.PACKAGES);
        } else if (floatingNavStatus === FloatingNav.FloatingNavStatus.PACKAGES) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
        if (workshopsInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.WORKSHOPS);
        } else if (floatingNavStatus === FloatingNav.FloatingNavStatus.WORKSHOPS) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
        if (topInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
        if (trainingsInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TRAININGS);
        } else if (floatingNavStatus === FloatingNav.FloatingNavStatus.TRAININGS) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
        if (aboutInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.ABOUT);
        } else if (floatingNavStatus === FloatingNav.FloatingNavStatus.ABOUT) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
        if (contactInView.inView) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.CONTACT);
        } else if (floatingNavStatus === FloatingNav.FloatingNavStatus.CONTACT) {
            setFloatingNavStatus(FloatingNav.FloatingNavStatus.TOP);
        }
    }, [
        packagesInView.inView,
        contactInView.inView,
        aboutInView.inView,
        trainingsInView.inView,
        topInView.inView,
        workshopsInView.inView,
        floatingNavStatus
    ]);
    const startYear = 2015;
    const yearsOfExperience = new Date().getFullYear() - startYear;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_FloatingNav, {
                scroller: scroller,
                floatingNavStatus: floatingNavStatus,
                initialShowStatus: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                scroller: scroller,
                floatingNavStatus: floatingNavStatus
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Scrumify - We Help Teams Build Value-Driven Software By Providing Hands-On Scrum Trainings",
                description: "Powering Up Software Teams.",
                openGraph: {
                    url: "https://www.scrumify.at",
                    title: "Scrumify",
                    description: "Powering Up Software Teams.",
                    images: [
                        {
                            url: "https://res.cloudinary.com/bt101/image/upload/v1674077719/opengraph_ai_retro_ieth6r.png",
                            width: 1200,
                            height: 630,
                            alt: "Oana & Benjamin - Scrumify",
                            type: "image/png"
                        }
                    ],
                    site_name: "Scrumify"
                },
                twitter: {
                    handle: "@benithors",
                    site: "@benithors",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " break-word flex h-full min-h-screen w-full flex-col sm:break-normal   ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Scrumify"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "icon",
                                href: "/favicon.ico"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopSection, {
                        name: "topScrollToElement",
                        className: " flex h-[calc(100vh-100px)] max-h-[1200px] min-h-[600px] w-full flex-col items-center justify-center sm:min-h-[700px] md:h-[calc(100vh-150px)] md:min-h-[500px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: topInView.ref,
                            className: "w-sc relative flex h-full flex-col items-center overflow-hidden font-mono",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                    id: "gradient-canvas",
                                    className: "-z-20 h-full w-screen  "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                                    className: "absolute flex h-full w-full flex-col items-center md:flex-row md:items-end md:justify-center  ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-screen bg-brand-black   md:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                                className: "py-4 pl-4     "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex h-full flex-grow flex-row items-end md:mb-12 md:mr-4 lg:mb-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative mt-8 flex   flex-col flex-wrap text-white ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col font-mono text-6xl font-extrabold sm:text-7xl md:text-6xl lg:text-[5rem]   ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AnimatedWord, {
                                                                gradient: "bg-gradient-to-l from-brand-turquoise to-purple-600",
                                                                animate: animStatusInstance === animStatus.ONE,
                                                                word: "TRAIN"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AnimatedWord, {
                                                                gradient: "bg-gradient-to-l from-brand-pink to-brand-turquoise",
                                                                animate: animStatusInstance === animStatus.TWO,
                                                                word: "ITERATE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AnimatedWord, {
                                                                gradient: "bg-gradient-to-r from-brand-pink to-purple-600",
                                                                animate: animStatusInstance === animStatus.THREE,
                                                                word: "EVOLVE"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-4 mt-8   flex h-14 w-full flex-row justify-start  md:items-baseline ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopInButton, {
                                                            type: "button",
                                                            ariaLabel: "Scroll to the next section explaining our services",
                                                            onClick: ()=>{
                                                                scroller.scrollTo("startNowScrollToElement", {
                                                                    duration: 1500,
                                                                    delay: 100,
                                                                    smooth: true
                                                                });
                                                            },
                                                            children: "SHOW ME HOW"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex w-full flex-row  items-end sm:w-3/4 md:w-[27rem] lg:w-2/4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "-z-10  w-full translate-y-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: us_no_bg,
                                                    width: 1370,
                                                    height: 1080,
                                                    priority: true,
                                                    alt: "Oana Moraru and Benjamin Thorstensen"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StartNowSection, {
                        name: "startNowScrollToElement",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col items-center   bg-white ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    className: "absolute left-0 top-3/4 translate-y-[0.04rem] ",
                                    width: "48",
                                    height: "115",
                                    viewBox: "0 0 48 115",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M25.1586 41.9961C10.6258 34 10.2731 34.9979 0 27V95.4823V112.978C38.3668 126.474 70.5 66.9436 25.1586 41.9961Z",
                                            fill: "url(#paint0_linear_0_1)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M0 0V53.5C33 51.5 33 4 0 0Z",
                                            fill: "#FF00B5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_0_1",
                                                x1: "47",
                                                y1: "80.5",
                                                x2: "-12.0726",
                                                y2: "85.0493",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        stopColor: "#00FFD9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "1",
                                                        stopColor: "#00FFD9",
                                                        stopOpacity: "0"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                                    className: "flex flex-col items-center justify-between   py-12  md:pb-14 md:pt-24",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " z-10 flex  flex-col  text-xl font-bold ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-center tracking-[0.2em] text-brand-text-turquoise",
                                                    children: "Our Mission"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "max-w-[600px]  text-center font-mono text-3xl font-bold   tracking-wide md:text-5xl",
                                                    children: "Accelerating success with hands-on trainings."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-col items-center justify-center space-y-8 pt-8  md:flex-row md:space-y-0 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BeforeTeam, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex  w-48 flex-col items-center  ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-20",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            className: "rotate-90 md:rotate-0",
                                                            width: "100%",
                                                            height: "100%",
                                                            viewBox: "0 0 486 497",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M210.5 25L459 270",
                                                                    stroke: "#FF00B5",
                                                                    strokeWidth: "70"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M215 472.5L460.5 222",
                                                                    stroke: "#FF00B5",
                                                                    strokeWidth: "70"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M0 247H417",
                                                                    stroke: "#FF00B5",
                                                                    strokeWidth: "70"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AfterTeam, {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full flex-col items-center text-white ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                            className: "flex w-screen flex-col items-center ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-14 flex flex-col items-center justify-center text-xl font-bold ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center md:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full text-center md:w-1/2 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "tracking-[0.2em] text-brand-pink",
                                                    children: "Hands-on Trainings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pt-4 font-mono text-3xl  font-extrabold md:text-5xl lg:text-7xl",
                                                    children: "Why us?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full md:w-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: " list-disc py-8 pl-12 pt-8  font-sans text-base font-normal tracking-normal ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "ALL SCRUM accountabilities perspectives covered"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "8 years of Agile Product Development experience per Trainer"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Hands-on Training & Workshop moderation"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Real-life project experiences, stories & examples"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Answers to your questions from two different perspectives"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Male-Female Trainer combination provides the opportunity for bond & trust building"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PackagesSection, {
                        name: "packages",
                        className: "flex w-full flex-col items-center  bg-cyan-900",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                            className: "flex w-screen flex-col items-center py-20 lg:py-24 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionHeader, {
                                    subtitleClassName: "text-center pt-8 pb-8 ",
                                    title: "PACKAGES",
                                    subtitle: "Choose a Package that's right for your Team"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: packagesInView.ref,
                                    className: "lg:grid-auto-flow grid  w-full gap-x-[3px]  gap-y-[1px] lg:auto-cols-fr lg:auto-cols-max lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                            duration: "duration-1000",
                                            title: "Essential",
                                            packageDetails: [
                                                "1 Day",
                                                "6-12 Persons"
                                            ],
                                            subtitle: "SCRUM Overview Kickstarter",
                                            description: "Get started with SCRUM and learn by hands-on Trainings",
                                            features: [
                                                "Hands-on SCRUM Introduction Training"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                            duration: "duration-1000  lg:delay-150",
                                            title: "Starter",
                                            packageDetails: [
                                                "4 Days",
                                                "6-12 Persons"
                                            ],
                                            subtitle: "SCRUM Accountabilities Deep Dive",
                                            description: "Level Up your SCRUM knowledge",
                                            features: [
                                                "Hands-on SCRUM Introduction Training",
                                                "Hands-on SCRUM Product Owner Training",
                                                "Hands-On SCRUM Developer Training",
                                                "Hands-on SCRUM Master Training"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                            duration: "duration-1000 lg:delay-300",
                                            title: "Team",
                                            packageDetails: [
                                                "7 Days",
                                                "6-12 Persons"
                                            ],
                                            subtitle: "SCRUM Team Ready to Go",
                                            description: "The full Package for upcoming SCRUM Superheroes",
                                            features: [
                                                "Hands-on SCRUM Introduction Training",
                                                "Hands-on SCRUM Product Owner Training",
                                                "Hands-On SCRUM Developer Training",
                                                "Hands-on SCRUM Master Training",
                                                "Agile Evolution Starter Workshop",
                                                "Product Backlog Setup Workshop",
                                                "Prioritization Workshop",
                                                "Process & Workflow Workshop"
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full flex-row items-center justify-center"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Custom, {
                                    title: "Custom",
                                    className: "mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "pt-4 md:text-center",
                                            children: [
                                                "Customized, Hands-on Trainings for Your Team.",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Get in contact with us for a solution that fits your needs."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-20 w-full pb-2  pt-4  lg:w-2/3 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopInButton, {
                                                href: "mailto:hello@scrumify.at",
                                                type: "mail",
                                                ariaLabel: "Write an email to us",
                                                children: "Let's talk!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookACall, {
                                                className: "text-sm lg:text-center"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopInButton, {
                                    type: "button",
                                    ariaLabel: "Scroll to Trainings section",
                                    className: "mt-8 h-11",
                                    backgroundColor: " bg-brand-black ",
                                    onClick: ()=>{
                                        scroller.scrollTo("trainings", {
                                            duration: 1500,
                                            delay: 100,
                                            smooth: true
                                        });
                                    },
                                    children: "See all Trainings!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsribeSection/* default */.Z, {
                        text: "Signup to our Newsletter and get exclusive Team Building tips that we only share with e-mail\n" + "                            Subscribers!",
                        tag: "Teambuilding"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutSection, {
                        name: "about",
                        className: "flex w-full flex-col items-center ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: aboutInView.ref,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                                className: "flex w-screen flex-col items-center py-20 lg:py-24",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionHeader, {
                                        subtitleClassName: "text-center pt-8 pb-8 ",
                                        title: "ABOUT",
                                        subtitle: "Meet the two passionate Trainers for your upcoming Training"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                                        className: "md:flex-row-reverse",
                                        email: "oana.moraru@scrumify.at",
                                        linkedin: "https://www.linkedin.com/in/oana-moraru/",
                                        music: "https://ardenite.net/",
                                        slogan: "My heart beats Agile",
                                        image: Oana,
                                        title: "Oana Moraru",
                                        imageTranslationDirection: "-translate-x-96",
                                        textTranslationDireciton: "translate-x-96",
                                        children: [
                                            "Hi, I am Oana! - SCRUM Trainer, Agile Coach and Frontwoman of the Cyber Pop Rock Band",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: "https://ardenite.net/",
                                                className: "underline underline-offset-2",
                                                children: "ARDENITE"
                                            }),
                                            "!",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Becoming the best version of myself and inspiring others is something I'm constantly striving to achieve. And I will help you and your teams to do the same!",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "In the past ",
                                            yearsOfExperience,
                                            " years, I have gathered experience in all Scrum accountabilities, including Developer, Product Owner and Scrum Master. During that time, I helped multiple teams kick off or boost their way of working by using SCRUM.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Not once did I experience a team that did not benefit from this approach, nor did any of them want to go back to their previous way of working after experiencing it once in my presence.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                                        className: "pt-16 md:flex-row",
                                        email: "benjamin.thorstensen@scrumify.at",
                                        linkedin: "https://www.linkedin.com/in/benithors/",
                                        twitter: "https://twitter.com/benithors",
                                        slogan: "This is where the fun begins",
                                        image: Benjamin,
                                        title: "Benjamin Thorstensen",
                                        imageTranslationDirection: "translate-x-96",
                                        textTranslationDireciton: "-translate-x-96",
                                        children: [
                                            "Hi, I am Benjamin, after attending many boring trainings I decided to go on a mission: I would bring back the fun and excitement in trainings! I believe positive emotions, such as enjoyment, are key to long-lasting learning and training experiences.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "I spent the past ",
                                            yearsOfExperience,
                                            " years building software, leading teams to become self-organized, training software engineers to become the best version of themselves and shipping multiple products from draft to go live. At the peak, it was time for me to leave and start my mission to be a SCRUM Trainer, Agile Coach with a computer science background."
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainingsSection, {
                        name: "trainings",
                        className: "flex w-full flex-col items-center bg-cyan-900 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: trainingsInView.ref,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                                className: "flex w-screen flex-col items-center pb-20 pt-20 lg:pt-24",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionHeader, {
                                        subtitleClassName: "text-center pt-8 pb-8 ",
                                        title: "TRAININGS",
                                        subtitle: "Choose a Trainings that's right for your Team"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:grid-auto-flow grid  w-full gap-x-[3px]  gap-y-[1px] lg:auto-cols-fr lg:auto-cols-max lg:grid-flow-col lg:grid-cols-2 lg:grid-rows-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                                duration: "duration-1000",
                                                title: "Hands-On SCRUM Introduction",
                                                packageDetails: [
                                                    "1 Day",
                                                    "6-12 Persons"
                                                ],
                                                lastPoint: "Recommended for anybody & everybody who wants to learn about SCRUM & Agile",
                                                description: "Get started with SCRUM and learn by hands-on Trainings",
                                                features: [
                                                    "Overview & basics of SCRUM & Agile",
                                                    "Hands-on exercises",
                                                    "Various RL examples from experience",
                                                    "Self-reflection superpowers"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                                duration: "duration-1000 lg:delay-150",
                                                title: "SCRUM Customer Collaboration",
                                                packageDetails: [
                                                    "1 Day",
                                                    "6-12 Persons"
                                                ],
                                                lastPoint: "Recommended for Customers Single Points of Contact & Stakeholders working with a SCRUM team",
                                                description: "Level Up your SCRUM knowledge",
                                                features: [
                                                    "SCRUM Overview & Deep-dive from the Customer&apos;s\n" + "Perspective",
                                                    "RL examples & hands-on exercises",
                                                    "SCRUM Customer benefits, responsibility Kickstarter\n"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:grid-auto-flow grid  w-full gap-x-[3px]  gap-y-[1px] lg:mt-8 lg:auto-cols-fr lg:auto-cols-max lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                                duration: "duration-1000 lg:delay-150",
                                                title: "Hands-On SCRUM Product Owner",
                                                packageDetails: [
                                                    "1 Day",
                                                    "6-12 Persons"
                                                ],
                                                lastPoint: "Recommended for (upcoming) Product Owners, as well as anybody working with them, such as Developers & Scrum Masters, Leadership, etc.",
                                                description: "Level Up your SCRUM knowledge",
                                                features: [
                                                    "RL examples & hands-on exercises",
                                                    "Product Owner Toolbox Kickstarter"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                                duration: "duration-1000 lg:delay-150",
                                                title: "Hands-On SCRUM Developer",
                                                packageDetails: [
                                                    "1 Day",
                                                    "6-12 Persons"
                                                ],
                                                lastPoint: "Recommended for Junior & Senior Developers\n" + "working in a SCRUM team, as well as anybody\n" + "working with them",
                                                description: "Level Up your SCRUM knowledge",
                                                features: [
                                                    "Dive deeper into the SCRUM Developer",
                                                    "RL examples & hands-on exercises",
                                                    "Developer ownership and self-management Kickstarter"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Package, {
                                                duration: "duration-1000 lg:delay-150",
                                                title: "Hands-On SCRUM Master",
                                                packageDetails: [
                                                    "1 Day",
                                                    "6-12 Persons"
                                                ],
                                                lastPoint: "Recommended for (upcoming) SCRUM Masters working in a SCRUM team, as well as anybody working with them",
                                                description: "Level Up your SCRUM knowledge",
                                                features: [
                                                    "Dive deeper into the SCRUM Master",
                                                    "RL examples & hands-on exercises",
                                                    "SCRUM Master responsibility Kickstarter"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsribeSection/* default */.Z, {
                        tag: "AI",
                        text: "Signup to our Newsletter and get exclusive Team Building tips that we only share with e-mail\n" + "                            Subscribers!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSection, {
                        name: "contact",
                        className: "flex w-full flex-col    items-center overflow-hidden  bg-cyan-900",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                            className: "flex w-screen flex-col items-center ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: contactImageSectionInView.ref,
                                className: "mt-4 flex h-[calc(100vh/2)] max-h-[600px] min-h-[400px] w-full flex-col  items-center     md:flex-row md:justify-around " + (0,Transitions/* getOpacityFromBottomTransition */.$)(contactImageSectionInView.inView),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "md:order-0 order-1 flex  h-full w-full flex-row justify-around",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-fit max-h-[400px]    w-4/5 self-end   ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: getInContact,
                                                width: 1200,
                                                height: 1200,
                                                sizes: "30vw",
                                                alt: "Oana Moraru and Benjamin Thorstensen"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex h-full w-full flex-row    items-center justify-center ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex  w-full flex-col items-center md:block md:w-3/5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionHeader, {
                                                title: "CONTACT",
                                                subtitle: "We would love to talk with you!",
                                                subtitleClassName: "pt-2 "
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col items-center bg-white ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                            className: "flex flex-col justify-between  py-12 md:flex-row md:py-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full flex-col items-center justify-center " + (0,Transitions/* getOpacityFromBottomTransition */.$)(contactActionSectionInView.inView),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col items-center text-xl font-bold md:block md:w-3/5 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "tracking-[0.2em] text-brand-text-turquoise",
                                                children: "Questions?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "pt-4 text-center font-molle text-4xl  md:text-left md:text-5xl",
                                                children: "Get in touch with us!"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: contactInView.ref,
                                    className: "flex w-full flex-col justify-between" + (0,Transitions/* getOpacityFromBottomTransition */.$)(contactActionSectionInView.inView),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            ref: contactActionSectionInView.ref,
                                            className: "mt-4 text-center md:text-left",
                                            children: [
                                                "Part of our mission is to get to know like-minded people, so if you got any ideas, questions or simply want to join us on a hike, please email us at",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    href: "mailto:hello@scrumify.at",
                                                    className: " font-bold text-brand-pink underline ",
                                                    children: "hello@scrumify.at"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-8  h-14 w-2/3 self-center md:self-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopInButton, {
                                                href: "mailto:hello@scrumify.at",
                                                type: "submit",
                                                ariaLabel: "Write and email to us",
                                                children: "Get in touch"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBar, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [891,486,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);